import { render, staticRenderFns } from "./BlogPosts-details.vue?vue&type=template&id=6e8a9eaa&scoped=true&"
import script from "./BlogPosts-details.vue?vue&type=script&lang=js&"
export * from "./BlogPosts-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a9eaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VOverlay})
